import { render, staticRenderFns } from "./m-switch.vue?vue&type=template&id=77d57e39&scoped=true"
import script from "./m-switch.vue?vue&type=script&lang=js"
export * from "./m-switch.vue?vue&type=script&lang=js"
import style0 from "./m-switch.vue?vue&type=style&index=0&id=77d57e39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d57e39",
  null
  
)

export default component.exports